import * as React from 'react';

function SvgMapMarkerLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={38} height={44} viewBox="0 0 38 44" {...props}>
      <path d="M38 1H0v24l19 19 19-19z" />
      <path
        fill="#F6F6FF"
        d="M26.4 17.12V9h-3.04v8.12L19 12.84l-4.36 4.28V9H11.6v8.12l-4.36-4.28L5 15.04 13.12 23 19 17.24 24.88 23 33 15.04l-2.24-2.2z"
      />
    </svg>
  );
}

export default SvgMapMarkerLogo;
